import { createSignal, For } from "solid-js";
import { BaseFilter } from "./BaseFilter";
import { Calendar } from "@/components/shadcn/calendar"

export const DateFilter = (props) => {

  const [value, setValue] = createSignal(null);
  const [operator, setOperator] = createSignal('eq');

  const onDateChange = (date) => {

    setValue(date);

    props.onFilter(props.filter, operator(), value())
  }

  return (
    <BaseFilter class="w-auto" onBack={props.onBack} onClose={props.onClose}>
      <Calendar
        date={value()}
        onChange={onDateChange}
      />
    </BaseFilter>
  );
}
